document.addEventListener('DOMContentLoaded', () => {
  const banners = document.querySelectorAll('.ddm-banner[data-end-unix]');
  if (!banners.length) return;

  function fmt(n) {
    return n.toString().padStart(2, '0');
  }

  function tick() {
    const now = Date.now();
    banners.forEach(banner => {
      const endUnix = parseInt(banner.getAttribute('data-end-unix'), 10);
      const endMs = isNaN(endUnix) ? 0 : endUnix * 1000;
      const timer = banner.querySelector('.ddm-banner__timer');
      if (!timer || !endMs) return;
      const diff = endMs - now;
      if (diff <= 0) {
        timer.textContent = '00:00:00:00';
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const mins = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const secs = Math.floor((diff % (1000 * 60)) / 1000);
      timer.textContent = `${fmt(days)}d:${fmt(hours)}:${fmt(mins)}:${fmt(secs)}`;
    });
  }

  tick();
  setInterval(tick, 1000);
});


